const BASE_URL = `${window.location.protocol}//${window.location.host}`;

async function parseResponse(res) {
    const text = await res.text();
    let data = null;
    try {
        data = text ? JSON.parse(text) : null;
    } catch {
        data = null;
    }

    if (res.status >= 500) {
        throw new Error(data?.message || data?.error || `Server error (${res.status})`);
    }
    return { status: res.status, ok: res.ok, data };
}

/**
 * List all External API keys (never includes the secret)
 */
export async function listApiKeys() {
    const res = await fetch(`${BASE_URL}/api/external-api-keys`, {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
    });
    return parseResponse(res);
}

/**
 * Generate a new External API key for an application. The full plaintext key
 * is only ever returned in this response.
 */
export async function generateApiKey(applicationName) {
    const res = await fetch(`${BASE_URL}/api/external-api-keys`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ applicationName }),
    });
    return parseResponse(res);
}

/**
 * Revoke an External API key by id
 */
export async function revokeApiKey(id) {
    const res = await fetch(`${BASE_URL}/api/external-api-keys/${id}/revoke`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
    });
    return parseResponse(res);
}
